module.exports = __webpack_public_path__ + "./img/logo-horizontal.51a9586e28055239714548ebb663bf24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-horizontal.png
// module id = ./src/assets/img/logo-horizontal.png
// module chunks = 11